import React, { useEffect, useState, useRef, props } from "react";
import { compose } from "redux";
import _ from "lodash";
import SignatureCanvas from "react-signature-canvas";
import {
    Row,
    Col,
    Button,
    Dropdown,
    Form,
    Table,
    Modal,
    Input,
    Space,
    Card,
    message,
    Select
} from "antd";

import TechBaseText from "DisplayCoreV2/Text";

import WithParamsHOC from "containers/Actions/params";
import {
    ValidateICRule,
    requireRule,
    validateMobileNumberRule,
} from "utils/rules";
import TechBaseButton from "DisplayCoreV2/Button";
import TechBaseFilter from "DisplayCoreV2/Filter";
import { orderStatusCode } from "constants";
import { thousandSeperatorFormatter } from "utils";
import TechbaseMemberFinder from "DisplayCoreV2/MemberFinder";
import { requestError } from "utils/requestHandler";
import { handleErrorMsg } from "utils";
import { Post } from "utils/axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";




const LotReport = (props) => {
    const [AuthorizeForm] = Form.useForm();
    const [EditForm] = Form.useForm();
    const canvasParent = useRef();
    const [signCanvasRef, updateSignCanvasRef] = useState();
    const [canvasWidth, setCanvasWidth] = useState(0);
    const [editModal, setEditModal] = useState({
        visible: false,
        field: "",
        value: "",
        title: "",
    });
    const [selectedUnitType, setSelectedUnitType] = useState(null);

const [selectedArea, setSelectedArea] = useState({
  unitType: null,
  ZoneX: null,
  BlockX: null,
  Hall: null,
  Side: null,
});


const getZoneOptions = (unitType) => {
    if (!unitProperties?.availableCombinations) return [];
  
    const displayName = unitProperties?.unitType?.find(u => u.Value === unitType)?.DisplayName;
    const combos = unitProperties?.availableCombinations?.[displayName];
  
    return _.uniqBy(combos, "Zone")?.map(z => ({
      label: z.zone,
      value: z.zone,
    })) || [];
  };
  


    const {
        query = { pageNumber: 1, pageSize: 10 },
        orders,
        profile,
        productCategories,
        showAddSignatureModal,
        showAddAuthRepModal,
        showDetailModal,
        onChangeHOC,
        getProductParamOptions,
        language,
        unitProperties
    } = props;



    const [totalReport, setTotalReport] = useState(0);

    const [floorPlans, setFloorPlans] = useState([]);
    //   useEffect(() => {
    //     getProductParamOptions();
    //     fetchFloorPlans();
    //   }, []);

    useEffect(() => {
        fetchFloorPlans();
    }, [props.query]);


    const [zoneOptions, setZoneOptions] = useState([]);
    const [unitTypeOptions, setUnitTypeOptions] = useState([]);
    const [sideOptions, setSideOptions] = useState([]);



    const fetchFloorPlans = () => {
        // First fetch all possible data for filter options
        Post(
            "/product/getFloorPlanList",
            {
                pageNumber: 1,
                pageSize: 1000, // Get enough data for filter options
                unitStatus: "S",
                displayStatus: "S"
            },
            (res) => {
                const allData = res?.Data?.data || [];
                
                // Set filter options based on ALL data
                const unitTypes = _.uniqBy(allData, 'UnitType')
                    .filter(d => d.UnitType)
                    .map(d => ({
                        label: d.UnitType,
                        value: d.UnitType
                    }));
                setUnitTypeOptions(unitTypes);
    
                const zones = _.uniqBy(allData, 'ZoneX')
                    .filter(d => d.ZoneX)
                    .map(d => ({
                        label: d.ZoneX,
                        value: d.ZoneX
                    }));
                setZoneOptions(zones);
    
                const sideType = _.uniqBy(allData, 'Side')
                    .filter(d => d.Side)
                    .map(d => ({
                        label: d.Side,
                        value: d.Side
                    }));
                setSideOptions(sideType);
    
                // Then fetch the filtered data for display
                fetchFilteredData();
            },
            (err) => requestError(handleErrorMsg(err)),
            () => {} // Empty load callback
        );
    };
    
    const fetchFilteredData = () => {
        Post(
            "/product/getFloorPlanList",
            {
                ...query,
                pageNumber: 1,
                unitStatus: "S",
                displayStatus: "S"
            },
            (res) => {
                const data = res?.Data?.data || [];
                const total = res?.Data?.totalRows || 0;
                setFloorPlans(data);
                setTotalReport(total);
            },
            (err) => requestError(handleErrorMsg(err)),
            () => {} // Empty load callback
        );
    };

    const exportAllToExcel = async () => {
        const payload = {
            ...query,
            pageNumber: 1,
            pageSize: 999999, // or another large number to retrieve all
            unitStatus: "S",
            displayStatus: "S"
        };

        try {
            const res = await new Promise((resolve, reject) => {
                Post(
                    "/product/getFloorPlanList",
                    payload,
                    (res) => resolve(res),
                    (err) => reject(err),
                    () => { }
                );
            });

            const data = res?.Data?.data || [];

            if (!data.length) {
                message.warning("No data available to export.");
                return;
            }

            const exportData = data.map(item => ({
                UnitID: item.UnitID,
                UnitType: item.UnitType,
                PositionX: item.PositionX,
                PositionY: item.PositionY,
                ZoneX: item.ZoneX,
                Hall: item.Hall,
                BlockX: item.BlockX,
                Side: item.Side,
                RowX: item.RowX,
                AreaSize: item.AreaSize,
                UnitStatusX: item.UnitStatusX,
                DisplayStatusX: item.DisplayStatusX,
                ReferencePrice: item.ReferencePrice,
                ReferenceContinuityFee: item.ReferenceContinuityFee,
                UserCapacity: item.UserCapacity,
                SalesId: item.SalesId,
                AgentID: item.AgentID,
                AgentName: item.AgentName,
                PurchaserID: item.PurchaserID,
                PurchaserName: item.PurchaserName,
                UnitPrice: item.UnitPrice,
                MaintenanceFee: item.MaintenanceFee,
                UnitDiscount: item.UnitDiscount,
                Downpayment: item.Downpayment,
                InstallmentPaid: item.InstallmentPaid,
                BackWallAmount: item.BackWallAmount,
                BalancePayable: item.BalancePayable,
                NeedCondition_EN: item.NeedCondition_EN,
                NeedConditionName_ZH: item.NeedConditionName_ZH,
                IntendedUsersCount: item.IntendedUsers?.length || 0,
                IntendedUsersDetails: item.IntendedUsers?.map(u => u.FullName).join(", ") || ""
            }));

            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "FloorPlanReport");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
            saveAs(blob, "FloorPlanReport.xlsx");
        } catch (error) {
            requestError(handleErrorMsg(error));
        }
    };

    const { can_read } = props.permission ?? {};

    const columns = [
        {
            title: <TechBaseText Tag="div" content="{{NO}}." />,
            render: (text, record, index) =>
                (query.pageNumber - 1) * query.pageSize + index + 1,
        },
        {
            title: <TechBaseText Tag="div" content="{{UNIT_ID}}" />,
            dataIndex: "UnitID",
            key: "UnitID",
            onCell: () => ({ style: { whiteSpace: "nowrap" } }),
        },
        {
            title: <TechBaseText Tag="div" content="{{UNIT_TYPE}}" />,
            dataIndex: "UnitType",
            key: "UnitType",
            align: "center",
            onCell: () => ({ style: { whiteSpace: "nowrap" } }),
        },
        {
            title: <TechBaseText Tag="div" content="{{DETAILS}}" />,
            //dataIndex: "SalesID",
            key: "details",
            render: (text, record) => (
                <div>
                    {record.ZoneX && (
                        <div>Zone: {record.ZoneX}</div>
                    )}
                    {/* {record.PositionX &&(
                <div>PositionX: {record.PositionX}</div>
            )}
            {record.PositionY &&(
                <div>PositionY: {record.PositionY}</div>
            )} */}
                    {record.PositionX && record.PositionY && (
                        <div>Position: ({record.PositionX}, {record.PositionY})</div>
                    )}
                    {record.RowX && (
                        <div>RowX: {record.RowX}</div>
                    )}
                    {record.AreaSize && (
                        <div>AreaSize: {record.AreaSize}</div>
                    )}
                </div>
            ),
            onCell: () => ({ style: { whiteSpace: "nowrap" } }),
        },
        // {
        //   title: <TechBaseText Tag="div" content="{{PAYMENT}} (RM)" />,
        //   key: "payment",
        //   width: 180,
        //   render: (text, record) => (
        //     <div>
        //       {!_.isUndefined(record.TotalPayment) && (
        //         <TechBaseText
        //           Tag="div"
        //           content={`({{UNIT_PRICE}}: ${thousandSeperatorFormatter(record.UnitPrice)})`}
        //         />
        //       )}
        //       {!_.isUndefined(record.MaintenanceFee) && (
        //         <TechBaseText
        //           Tag="div"
        //           content={`({{MAINTENANCE_FEE}}: ${thousandSeperatorFormatter(record.MaintenanceFee)})`}
        //         />
        //       )}
        //     </div>
        //   ),
        // },
        // {
        //     title: <TechBaseText Tag="div" content="{{UnitStatusX}}" />,
        //     dataIndex: "UnitStatusX",
        //     key: "UnitStatusX",
        //     align: "center",
        // },
        // {
        //     title: <TechBaseText Tag="div" content="{{DisplayStatusX}}" />,
        //     dataIndex: "DisplayStatusY",
        //     key: "DisplayStatusY",
        //     align: "center",
        // },
        {
            title: <TechBaseText Tag="div" content="{{REFERENCE_PRICE}}" />,
            dataIndex: "ReferencePrice",
            key: "ReferencePrice",
            render: (text) => thousandSeperatorFormatter(text),
        },
        {
            title: <TechBaseText Tag="div" content="{{REFERENCE_CONTINUITY_FEE}}" />,
            dataIndex: "ReferenceContinuityFee",
            key: "ReferenceContinuityFee",
            render: (text) => thousandSeperatorFormatter(text),
        },
        {
            title: <TechBaseText Tag="div" content="{{SALES_ID}}" />,
            dataIndex: "SalesId",
            key: "SalesId",
        },
        {
            title: <TechBaseText Tag="div" content="{{AGENT_ID}}" />,
            dataIndex: "AgentID",
            key: "AgentID",
        },
        {
            title: <TechBaseText Tag="div" content="{{AGENT_NAME}}" />,
            dataIndex: "AgentName",
            key: "AgentName",
        },
        {
            title: <TechBaseText Tag="div" content="{{PURCHASER_ID}}" />,
            dataIndex: "PurchaserID",
            key: "PurchaserID",
        },
        {
            title: <TechBaseText Tag="div" content="{{PURCHASER_NAME}}" />,
            dataIndex: "PurchaserName",
            key: "PurchaserName",
        },
        {
            title: <TechBaseText Tag="div" content="{{NEED_CONDITION}}" />,
            key: "NeedCondition",
            align: "center",
            render: (text, record) => {
                const { NeedCondition_EN, NeedConditionName_ZH, NeedConditionName_MS } = record;
                const lang = language || "en";

                const displayLang =
                    lang === "zh"
                        ? NeedConditionName_ZH
                        : lang === "ms"
                            ? NeedConditionName_MS
                            : NeedCondition_EN;

                return <div>{displayLang || "-"}</div>;
            }
        },
        {
            title: <TechBaseText Tag="div" content="{{INTENDED_USER}}" />,
            key: "IntendedUsersCount",
            align: "center",
            render: (text, record) => {
                const count = record.IntendedUsers?.length || 0;
                return <div>{count}</div>;
            }
        }

    ];

    

    // const filterFields = [
    //     {
    //         type: "input",
    //         name: "unitID",
    //         label: "{{UNIT_ID}}",
    //         lg: { span: 8, order: 1 },
    //     },
    //     {
    //         type: "custom",
    //         render: () => (
    //           <Row className="w-100 d-flex mb-3" gutter={16}>
    //             <Col flex="1">
    //               <div>Unit Type:</div>
    //               <Select
    //                 value={selectedArea.unitType}
    //                 options={[ 
    //                   { label: "B", value: "B" },
    //                   { label: "N", value: "N" },
    //                 ]}
    //                 size="large"
    //                 style={{ width: "100%" }}
    //                 placeholder="Select Unit Type"
    //                 onChange={(val) => {
    //                   setSelectedUnitType(val);
    //                   setSelectedArea({ unitType: val });
    //                 }}
    //               />
    //             </Col>

    //             <Col flex="1">
    //                 <div>Zone:</div>
    //                 <Select
    //                   value={selectedArea.zone}
    //                   options={getZoneOptions(selectedUnitType)}
    //                   size="large"
    //                   style={{ width: "100%" }}
    //                   placeholder="Select Zone"
    //                   onChange={(val) => setSelectedArea(prev => ({ ...prev, zone: val }))}
    //                 />
    //               </Col>
        
    //             {/* Show Block, Hall, Side only if N */}
    //             {selectedUnitType === "N" && (
    //               <>
    //                 <Col flex="1">
    //                   <div>Block:</div>
    //                   <Select
    //                   value={selectedArea.block}
    //                   options={getZoneOptions(selectedUnitType)}
    //                   size="large"
    //                   style={{ width: "100%" }}
    //                   placeholder="Select Block"
    //                 //   onChange={(e) => setSelectedArea(prev => ({ ...prev, block: e.target.value }))}
    //                 onChange={(val) => setSelectedArea(prev => ({ ...prev, block: val }))}

    //                 />
    //                 </Col>
    //                 <Col flex="1">
    //                   <div>Hall:</div>
    //                   <Select
    //                   value={selectedArea.hall}
    //                   options={getZoneOptions(selectedUnitType)}
    //                   size="large"
    //                   style={{ width: "100%" }}
    //                   placeholder="Select Hall"
    //                   onChange={(e) => setSelectedArea(prev => ({ ...prev, hall: e.target.value }))}
    //                 />
    //                 </Col>
    //                 <Col flex="1">
    //                   <div>Side:</div>
    //                   <Select
    //                   value={selectedArea.side}
    //                   options={getZoneOptions(selectedUnitType)}
    //                   size="large"
    //                   style={{ width: "100%" }}
    //                   placeholder="Select Side"
    //                   onChange={(e) => setSelectedArea(prev => ({ ...prev, side: e.target.value }))}
    //                 />
    //                 </Col>
    //               </>
    //             )}
    //           </Row>
    //         )
    //       },
    //     // {
    //     //     type: "select",
    //     //     name: "unitType",
    //     //     label: "{{UNIT_TYPE}}",
    //     //     options: [
    //     //         { label: "N", value: "N" },
    //     //         { label: "B", value: "B" },
    //     //     ],
    //     //     // onChange: (value) => setSelectedUnitType(value),
    //     //     lg: { span: 8, order: 2 },
    //     // },
    //     // {
    //     //     type: "select",
    //     //     name: "zone",
    //     //     label: "{{ZONE}}",
    //     //     options: [
    //     //         { label: "N", value: "N" },
    //     //         { label: "B", value: "B" },
    //     //     ],
    //     //     // onChange: (value) => setSelectedUnitType(value),
    //     //     lg: { span: 8, order: 2 },
    //     // },
    //     // {
    //     //     type: "input",
    //     //     name: "row",
    //     //     label: "{{ROW}}",
    //     //     lg: { span: 8, order: 4 },
    //     // },
    //     // {
    //     //     type: "input",
    //     //     name: "hall",
    //     //     label: "{{HALL}}",
    //     //     lg: { span: 8, order: 5 },
    //     // },
    //     // {
    //     //     type: "input",
    //     //     name: "block",
    //     //     label: "{{BLOCK}}",
    //     //     lg: { span: 8, order: 6 },
    //     // },
    //     // {
    //     //     type: "input",
    //     //     name: "side",
    //     //     label: "{{SIDE}}",
    //     //     lg: { span: 8, order: 7 },
    //     // },
    //     {
    //         type: "input",
    //         name: "salesID",
    //         label: "{{SALES_ID}}",
    //         lg: { span: 8, order: 3 },
    //     },
    //     {
    //         type: "input",
    //         name: "agentID",
    //         label: "{{AGENT_ID}}",
    //         lg: { span: 8, order: 4 },
    //     },
    //     {
    //         type: "input",
    //         name: "purchaserID",
    //         label: "{{PURCHASER_ID}}",
    //         lg: { span: 8, order: 5 },
    //     },
    // ];

    const filterFields = [
        {
            type: "input",
            name: "unitID",
            label: "{{UNIT_ID}}",
            lg: { span: 8, order: 1 },
        },
    
        {
            type: "select",
            name: "unitType",
            label: "{{UNIT_TYPE}}",
            options: unitTypeOptions,
            // options:[
            //     { label: "B", value: "B" },
            //     { label: "N", value: "N" },
            // ],
            // onChange: (value) => setSelectedUnitType(value),
            lg: { span: 8, order: 2 },
        },
        {
            type: "select",
            name: "zone",
            label: "{{ZONE}}",
            options: zoneOptions,
            // onChange: (value) => setSelectedUnitType(value),
            lg: { span: 8, order: 2 },
        },
        // {
        //     type: "input",
        //     name: "row",
        //     label: "{{ROW}}",
        //     lg: { span: 8, order: 4 },
        // },
        // {
        //     type: "input",
        //     name: "hall",
        //     label: "{{HALL}}",
        //     lg: { span: 8, order: 5 },
        // },
        // {
        //     type: "input",
        //     name: "block",
        //     label: "{{BLOCK}}",
        //     lg: { span: 8, order: 6 },
        // },
        {
            type: "select",
            name: "side",
            label: "{{SIDE}}",
            options:sideOptions,
            lg: { span: 8, order: 7 },
        },
        {
            type: "input",
            name: "salesID",
            label: "{{SALES_ID}}",
            lg: { span: 8, order: 3 },
        },
        {
            type: "input",
            name: "agentID",
            label: "{{AGENT_ID}}",
            lg: { span: 8, order: 4 },
        },
        {
            type: "input",
            name: "purchaserID",
            label: "{{PURCHASER_ID}}",
            lg: { span: 8, order: 5 },
        },
    ];

    useEffect(() => {
        getProductParamOptions();
    }, []);

    const onSubmitFilter = (formData) => {
        let tmp = _.omitBy(formData, _.isNil);


        if (tmp.salesDateFrom) {
            tmp.salesDateFrom = formData.salesDateFrom.format("YYYY-MM-DD");
        }
        if (tmp.salesDateTo) {
            tmp.salesDateTo = formData.salesDateTo.format("YYYY-MM-DD");
        }
        if (tmp.bookingDateFrom) {
            tmp.bookingDateFrom = formData.bookingDateFrom.format("YYYY-MM-DD");
        }
        if (tmp.bookingDateTo) {
            tmp.bookingDateTo = formData.bookingDateTo.format("YYYY-MM-DD");
        }

        const mappedFields = {
            UnitType: selectedArea.unitType,
            ZoneX: selectedArea.zone,
            BlockX: selectedArea.block,
            Hall: selectedArea.hall,
            Side: selectedArea.side,
        };
        

        onChangeHOC("query", {
            ...query,
            ...tmp,
            ...mappedFields,
            pageNumber: 1,
            pageSize: query.pageSize,
            salesType: [2],
        });
    };

    // FOr Zone?
    //   const onChangeFilter = (key, value) => {
    //     let tmp = _.cloneDeep({ ...selectedArea, [key]: value });
    //     switch (key) {
    //       case "unitType":
    //         tmp.zone =
    //           unitProperties?.availableCombinations?.[
    //             _.find(unitProperties.unitType, { Value: tmp.unitType })?.DisplayName
    //           ]?.[0]?.Zone;
    //       case "zone":
    //         delete tmp.block;
    //       case "block":
    //         delete tmp.hall;
    //       case "hall":
    //         delete tmp.side;
    //       case "side":
    //         onChangeHOC("selectedSlot", {});
    //       default:
    //     }
    //     setSelectedArea(tmp);
    //   };

    // console.log('LotReport props:', props);

    if (!can_read) {
        return <></>;
    }

    return (
        <div>
            <h3 className="text-capitalize">
                <TechBaseText content="{{LOT_FULL_DETAILS_REPORT}}" />
            </h3>
            <Row className="w-100">
                <TechBaseFilter
                    fields={filterFields}
                    onFinish={onSubmitFilter}
                    onReset={() =>
                        onChangeHOC("query", {
                            UnitID: null,
                            UnitType: null,
                            SalesId: null,
                            AgentID: null,
                            PurchaserID: null,
                            pageNumber: 1,
                            pageSize: 10,
                            salesType: [2],
                            unitStatus: "S",
                            displayStatus: "S"
                        })
                    }


                />
                <Row justify="end" style={{ marginBottom: 16 }}>
                    <Col>
                        <TechBaseButton
                            type="primary"
                            onClick={exportAllToExcel}
                            icon={<i className="fa fa-download" />}
                        >
                            Export to Excel
                        </TechBaseButton>
                    </Col>
                </Row>

                <Table
                    key={`table-${language}`}
                    bordered
                    className="techbase-table"
                    columns={columns}
                    dataSource={floorPlans}
                    pagination={{
                        current: query.pageNumber,
                        pageSize: query.pageSize,
                        total: totalReport,
                        showSizeChanger: true,
                        onChange: (page, pageSize) =>
                            onChangeHOC("query", {
                                ...query,
                                pageNumber: page,
                                pageSize: pageSize,
                            }),
                    }}

                    scroll={{ x: 1500 }}
                />
            </Row>
        </div>
    );
};

export default WithParamsHOC(LotReport);
